import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics Route Tracker
// Tracks page views on route changes

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
        send_to: 'G-3GEVFP3QYL'
      });
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default RouteTracker;
